<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)" v-loading="loading">
      <div class="form-group">
        <label>Contact Number</label>
        <ValidationProvider name="contact_number" rules="" v-slot="{ passed, failed }">
          <fg-input type="number" :error="failed ? 'The name field is required' : null" :hasSuccess="passed"
            name="contact_number" v-model="form.contact_number">
          </fg-input>
        </ValidationProvider>
      </div>
      <div class="form-group">
        <label>Email</label>
        <ValidationProvider name="email" rules="required|email" v-slot="{ passed, failed }">
          <fg-input type="text" :error="failed ? 'The email field format is invalid' : null" :hasSuccess="passed"
            name="email" v-model="form.email">
          </fg-input>
        </ValidationProvider>
      </div>

      <div class="form-group">
        <label>Password</label>
        <ValidationProvider vid="confirmation" name="password" :rules="{
  required: (form.password ? true : false),
    regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
  }" v-slot="{ passed, failed }">
          <fg-input type="password"
            :error="failed ? 'The Password must be at least 8 characters and has a number' : null" :hasSuccess="passed"
            name="password" v-model="form.password">
          </fg-input>
        </ValidationProvider>
      </div>
      <div class="form-group" v-if="form.password">
        <label>Confirm Password</label>
        <ValidationProvider rules="required|confirmed:confirmation" v-slot="{ passed, failed }">
          <fg-input type="password" :error="failed ? 'The confirm password must match your password.' : null"
            :hasSuccess="passed" name="confirm" v-model="form.confirmPassword">
          </fg-input>
        </ValidationProvider>
      </div>
      <div class="text-right">
        <p-button type="success" native-type="submit">Save</p-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  extend
} from "vee-validate";
import {
  required,
  email,
  confirmed,
  regex
} from "vee-validate/dist/rules";
import {
  User
} from '@/resources/user'

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);
extend("regex", regex);

export default {
  props: ['user'],
  components: {},
  data() {
    return {
      form: {
        email: "",
        name: "",
        password: null
      },
      loading: false
    };
  },
  created: function () {
    this.form = Object.assign({}, this.user)
  },
  methods: {
    submit() {
      this.loading = true
      let form = {
        id: this.form.id,
        email: this.form.email,
        contact_number: this.form.contact_number
      }

      if (this.form.password) {
        form.password = this.form.password
        form.confirm_password = this.form.confirmPassword
      }

      User.updateCredential(form)
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Account updated',
          });

          this.$store.commit('saveUser', result.data.user);
        })
        .catch(error => {

        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
